import { throttle } from 'lodash';

const MIN_INTERVAL_MS = 5000;
const SPREAD_MS = 2000;

/**
 * Schedules realtime resyncs. A request runs at once unless one ran in the
 * last 5 s (visibilitychange fires on every tab switch); then it runs when
 * that window ends, so a second reconnect soon after the first still gets
 * its own resync. Each run starts after a random 0-2 s, so the refetches of
 * every tab that reconnects during a rollout do not reach the new pods at once.
 */
export function createRealtimeResync(resync, random = Math.random) {
    let timer = null;
    const throttled = throttle(() => {
        timer = setTimeout(resync, random() * SPREAD_MS);
    }, MIN_INTERVAL_MS);
    return {
        request: () => throttled(),
        cancel: () => {
            throttled.cancel();
            clearTimeout(timer);
        },
    };
}
